<header class="content-header">
  <h4 class="vision-h4"
    *ngIf="sidebar.search.query || sidebar.search.searchMode === 'basic'">
    Basic Search</h4>
  <h4 class="vision-h4"
    *ngIf="sidebar.search.searchMode === 'advanced'">Advanced Search</h4>
</header>

<fw-alert
  *ngIf="(displayStatusWarning$ | async)"
  icon="warning"
  [severity]="(searchStatus$ | async) === 'error' ? 'error' : 'warning'"
  [description]="searchStatusMessage$ | async">
</fw-alert>

<ng-container *ngVar="(searchResultCounts$ | async) as counts">
  <mat-tab-group [(selectedIndex)]="tabIndex" (selectedTabChange)="changeTab($event)"
    mat-stretch-tabs="false" animationDuration="0ms" class="tabs-white content-body">
    <!-- Subjects -->
    <mat-tab test-id="subject-header-tab"
      label="{{ 'searchResults.tabLabels.subjects' | translate }} {{ counts.subject }}">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="results"></ng-container>
      </ng-template>
    </mat-tab>

    <!-- Sessions -->
    <mat-tab test-id="session-header-tab"
      label="{{ 'searchResults.tabLabels.sessions' | translate }} {{ counts.session }}">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="results"></ng-container>
      </ng-template>
    </mat-tab>

    <!-- Acquisitions -->
    <mat-tab test-id="acquistion-header-tab"
      label="{{ 'searchResults.tabLabels.acquisitions' | translate }} {{ counts.acquisition }}">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="results"></ng-container>
      </ng-template>
    </mat-tab>

    <!-- Files -->
    <mat-tab test-id="file-header-tab" label="{{ 'searchResults.tabLabels.files' | translate }} {{ counts.file }}">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="results"></ng-container>
      </ng-template>
    </mat-tab>

    <!-- Analyses -->
    <mat-tab test-id="analysis-header-tab"
      label="{{ 'searchResults.tabLabels.analyses' | translate }} {{ counts.analysis }}">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="results"></ng-container>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-template #results>
  <div class="tools">
    <!-- Actions -->
    <span class="actions-section">
      <button mat-button [matMenuTriggerFor]="actionMenu"
        class="action-button" test-id="search-action-button">
        {{ 'searchResults.actionMenuButton' | translate }}
        <mat-icon class="xs" iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <ng-container *ngIf="availableActions$ | async as actions">
          <div *ngIf="actions.downloadFiles.visible"
            [matTooltip]="actions.downloadFiles.disabled ? actions.downloadFiles.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="downloadFiles()"
              [disabled]="actions.downloadFiles.disabled"
              test-id="search-action-download-files">
              {{ 'searchResults.actionLabels.downloadFiles' | translate }}
            </button>
          </div>
          <div *ngIf="features.tagging"
            [matTooltip]="actions.modifyTags.disabled ? actions.modifyTags.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="modifyTags()"
              [disabled]="actions.modifyTags.disabled"
              test-id="search-action-modify-tags">
              {{ 'modifyTagsDialog.labels.modifyTags' | translate }}
            </button>
          </div>
          <div *ngIf="actions.addToCollection.visible"
            [matTooltip]="actions.addToCollection.disabled ? actions.addToCollection.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="addToCollection()"
              [disabled]="actions.addToCollection.disabled"
              test-id="search-action-add-to-collection">
              {{ 'searchResults.actionLabels.addToCollection' | translate
              }}
            </button>
          </div>
          <div *ngIf="actions.runGear.visible"
            [matTooltip]="actions.runGear.disabled ? actions.runGear.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="runBatchGear()"
              [disabled]="actions.runGear.disabled"
              test-id="search-action-run-gear">
              {{ 'searchResults.actionLabels.runGear' | translate }}
            </button>
          </div>
          <mat-divider
            *ngIf="actions.deleteContainers.visible"></mat-divider>
          <div *ngIf="actions.deleteContainers.visible"
            [matTooltip]="actions.deleteContainers.disabled ? actions.deleteContainers.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="deleteContainers()"
              [disabled]="actions.deleteContainers.disabled"
              test-id="search-action-delete-containers">
              {{ 'searchResults.actionLabels.deleteContainers' | translate
              }}
            </button>
          </div>
          <mat-divider
            *ngIf="actions.moveContainers.visible"></mat-divider>
          <div *ngIf="actions.moveContainers.visible"
            [matTooltip]="actions.moveContainers.disabled ? actions.moveContainers.tooltip : null"
            matTooltipPosition="right">
            <button *ngIf="actions.moveContainers.visible" mat-menu-item
              [matMenuTriggerFor]="moveContainers"
              [disabled]="actions.moveContainers.disabled"
              test-id="search-action-move-containers">
              {{ 'searchResults.actionLabels.moveSessions' | translate }}
            </button>
          </div>
          <mat-menu #moveContainers="matMenu">
            <button mat-menu-item (click)="moveSessionsToProject()"
              [disabled]="actions.moveContainers.disabled"
              test-id="search-action-move-to-project">{{
              'searchResults.actionLabels.project' | translate }}</button>
            <button mat-menu-item (click)="moveSessionsToSubject()"
              [disabled]="actions.moveContainers.disabled"
              test-id="search-action-move-to-subject">{{
              'searchResults.actionLabels.subject' | translate }}</button>
          </mat-menu>

          <mat-divider
            *ngIf="actions.createContainer.visible"></mat-divider>
          <div *ngIf="actions.createContainer.visible"
            [matTooltip]="actions.createContainer.disabled ? actions.createContainer.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="createNewSession()"
              [disabled]="actions.createContainer.disabled"
              test-id="search-action-create-session">
              {{ 'searchResults.actionLabels.createSession' | translate }}
            </button>
          </div>

          <div *ngIf="actions.createTrainingSet.visible"
            [matTooltip]="actions.createTrainingSet.disabled ? actions.createTrainingSet.tooltip : null"
            matTooltipPosition="right">
            <button mat-menu-item (click)="createTrainingSet()"
              [disabled]="actions.createTrainingSet.disabled"
              test-id="search-action-create-training-set">
              {{ 'searchResults.actionLabels.trainingSet' | translate }}
            </button>
          </div>
        </ng-container>
      </mat-menu>
      <mat-checkbox [(ngModel)]="truncateText" test-id="check-truncate"
        style="margin-left: 5px;">
        Single Line Rows
      </mat-checkbox>
    </span>

    <span class="export-pagination-section">
      <button mat-button (click)="exportCSV()" class="export-csv-button"
        test-id="export-csv-button"
        [disabled]="downloadIsDisabled || downloading"
        matTooltip="{{'searchResults.labels.tooltips.' + downloadTooltipMessage | translate}}">
        <mat-icon class="xs">download</mat-icon>
        {{ 'searchResults.labels.context.' + resultType | translate }}
        <mat-spinner *ngIf="downloading" [diameter]="16"></mat-spinner>
      </button>

      <!-- Pagination -->
      <button mat-button [matMenuTriggerFor]="pageMenu"
        class="pagination-button" test-id="search-pagination-button">
        {{ 'searchResults.pageInfo' | translate | interpolate:page?.size:page?.total }}
        <mat-icon class="xs" iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #pageMenu="matMenu">
        <button mat-menu-item (click)="changePageSize(100)"
          test-id="search-pagination-100">100</button>
        <button mat-menu-item (click)="changePageSize(250)"
          test-id="search-pagination-250">250</button>
        <button mat-menu-item (click)="changePageSize(500)"
          test-id="search-pagination-500">500</button>
        <button mat-menu-item (click)="changePageSize(1000)"
          test-id="search-pagination-1000">1000</button>
      </mat-menu>
    </span>
  </div>

  <!-- Results -->
  <mat-table [dataSource]="searchResults$" [trackBy]="getResultRowId"
    class="scroll-y" [class]="{'single-line-row': truncateText}">
    <!-- Checks -->
    <ng-container matColumnDef="checkbox">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox [checked]="allChecked$ | async"
          (change)="checkAllRows()"
          test-id="search-check-all"></mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let element"
        (click)="$event.stopPropagation()">
        <mat-checkbox
          [checked]="(checkedResultIds$ | async)?.has(element._id)"
          (change)="checkResultRow(element)"
          test-id="check-result"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="extendChecked">
      <mat-header-cell *matHeaderCellDef [attr.colspan]="10"
        class="check-all-cell">
        <span
          [innerHTML]="'searchResults.selectAll.partial' | translate | interpolate:page?.checked:page?.total | trusthtml"></span>
        <a (click)="extendCheckedRows()" test-id="search-extend-checked">{{
          'searchResults.selectAll.link' | translate }}</a>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="allChecked">
      <mat-header-cell *matHeaderCellDef [attr.colspan]="10"
        class="check-all-cell">
        <span
          [innerHTML]="'searchResults.selectAll.total' | translate | interpolate:page?.checked | trusthtml"></span>
      </mat-header-cell>
    </ng-container>

    <!-- Loading -->
    <ng-container matColumnDef="loadingIndicator">
      <mat-header-cell *matHeaderCellDef [attr.colspan]="10"
      class="fw-ghost-animation">
        <span>{{ 'common.labels.loading' | translate }}</span>
      </mat-header-cell>
    </ng-container>

    <!-- Filters -->
    <ng-container matColumnDef="hierarchy">
      <mat-header-cell *matHeaderCellDef #hierarchyHeaderCell>
        <div *ngIf="searchFilters.get('hierarchy') as control">
          <span>{{ 'searchResults.filters.hierarchy' | translate }}</span>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="hierarchy"
        [matTooltip]="hierarchyMap.get(element)?.pretty"
        matTooltipClass="tooltip-multiline">
        {{ truncateText ? hierarchyMap.get(element)?.short :
        hierarchyMap.get(element)?.pretty }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionTimestamp">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('sessionTimestamp') as control">
          <mat-datepicker-toggle *ngIf="!control.value"
            [for]="sessionTimestampDatepicker" class="xs">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            [matDatepicker]="sessionTimestampDatepicker"
            (click)="sessionTimestampDatepicker.open()"
            placeholder="{{ 'searchResults.filters.timestamp' | translate }}"
            autocomplete="off" test-id="session-timestamp-filter">
          <mat-datepicker #sessionTimestampDatepicker></mat-datepicker>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="session-timestamp">{{
        element._source.session?.timestamp | date:'yyyy-MM-dd HH:mm'
        }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionAge">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('sessionAge') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.age' | translate }}"
            autocomplete="off" test-id="session-age-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="session-age">{{
        ageInYears(element._source.session?.age) }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionLabel">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('sessionLabel') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.label' | translate }}"
            autocomplete="off" test-id="session-label-filter">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.session?.label }}"
          test-id="session-label">{{
          element._source.session?.label }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionModality">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('sessionModality') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.sessionModality' | translate }}"
            autocomplete="off" test-id="session-modality-filter">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.session?.modality }}"
          test-id="session-modality">{{
          element._source.session?.file_modalities?.join(', ') }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectTimestamp">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('subjectTimestamp') as control">
          <mat-datepicker-toggle *ngIf="!control.value"
            [for]="subjectTimestampDatepicker" class="xs"
            test-id="subject-timestamp-toggle">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            [matDatepicker]="subjectTimestampDatepicker"
            (click)="subjectTimestampDatepicker.open()"
            placeholder="{{ 'searchResults.filters.timestamp' | translate }}"
            autocomplete="off" test-id="subject-timestamp-filter">
          <mat-datepicker #subjectTimestampDatepicker
            test-id="subject-timestamp-picker"></mat-datepicker>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="subject-timestamp">{{
        element._source.subject?.created |
        date:'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectCode">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('subjectCode') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.subject' | translate }}"
            autocomplete="off" test-id="subject-code-filter">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.subject?.code }}"
          test-id="subject-code">{{
          element._source.subject?.code }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectSex">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('subjectSex') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.sex' | translate }}"
            autocomplete="off" test-id="subject-sex-filter">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.subject?.sex }}" test-id="subject-sex">
          {{ element._source.subject?.sex | titlecase }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectCohort">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('subjectCohort') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.cohort' | translate }}"
            autocomplete="off" test-id="subject-cohort-filter">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.subject?.cohort }}"
          test-id="subject-sex">{{ element._source.subject?.cohort }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectMlSet">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('subjectMlSet') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.mlset' | translate }}"
            autocomplete="off" test-id="subject-ml-set-input">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.subject?.mlset }}"
          test-id="subject-ml-set">{{ element._source.subject?.mlset }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="acquisitionTimestamp">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('acquisitionTimestamp') as control">
          <mat-datepicker-toggle *ngIf="!control.value"
            [for]="acquisitionTimestampDatepicker" class="xs">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            [matDatepicker]="acquisitionTimestampDatepicker"
            (click)="acquisitionTimestampDatepicker.open()"
            placeholder="{{ 'searchResults.filters.timestamp' | translate }}"
            autocomplete="off" test-id="acquisition-timestamp-filter">
          <mat-datepicker #acquisitionTimestampDatepicker></mat-datepicker>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element"
        test-id="acquisition-timestamp">{{
        element._source.acquisition?.timestamp | date:'yyyy-MM-dd HH:mm'
        }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="acquisitionLabel">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('acquisitionLabel') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.label' | translate }}"
            autocomplete="off" test-id="acquisition-label-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.acquisition?.label }}"
          test-id="acquisition-label">{{ element._source.acquisition?.label
          }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="acquisitionModality">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('acquisitionModality') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.acquisitionModality' | translate }}"
            autocomplete="off" test-id="acquisition-modality-filter">
        </div>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.acquisition?.modality }}"
          test-id="acquisition-modality">{{
          element._source.acquisition?.file_modalities &&
          element._source.acquisition?.file_modalities.join(', ') }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileTimestamp">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('fileTimestamp') as control">
          <mat-datepicker-toggle *ngIf="!control.value"
            [for]="fileTimestampDatepicker" class="xs">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            [matDatepicker]="fileTimestampDatepicker"
            (click)="fileTimestampDatepicker.open()"
            placeholder="{{ 'searchResults.filters.timestamp' | translate }}"
            autocomplete="off" test-id="file-timestamp-filter">
          <mat-datepicker #fileTimestampDatepicker></mat-datepicker>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="file-timestamp">{{
        element._source.file?.created
        | date:'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('fileName') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.name' | translate }}"
            autocomplete="off" test-id="file-name-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.file?.name }}" test-id="file-name">{{
          element._source.file?.name }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileClassifications">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('fileClassifications') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.fileClassifications' | translate }}"
            autocomplete="off" test-id="file-type-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.file?.classification }}"
          test-id="file-type">{{ classificationMap.get(element) }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileContainerType">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('fileContainerType') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.fileContainerType' | translate }}"
            autocomplete="off" test-id="file-container-type-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.file?.type }}"
          test-id="file-container-type">{{
          element._source.file.parent_ref?.type | titlecase }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileType">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('fileType') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.type' | translate }}"
            autocomplete="off" test-id="file-type-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="file-type">{{
        element._source.file?.type }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="projectLabel">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('projectLabel') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.project' | translate }}"
            autocomplete="off" test-id="project-label-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="project-label">{{
        element._source.project?.label }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileActions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element" class="list-action-buttons">
        <file-actions [file]="element._source.file"
          [container]="element.parent"
          [kabobFeatures]="fileActionFeatures"
          (afterDelete)="filterResults()"
          (click)="$event.stopPropagation()" test-id="file-actions">
          <button mat-icon-button class="xs blue">
            <mat-icon class="xs">more_vert</mat-icon>
          </button>
        </file-actions>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="analysisLabel">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('analysisLabel') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.label' | translate }}"
            autocomplete="off" test-id="analysis-label-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.analysis?.label }}"
          test-id="analysis-label">{{ element._source.analysis?.label }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="analysisTimestamp">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('analysisTimestamp') as control">
          <mat-datepicker-toggle *ngIf="!control.value"
            [for]="analysisTimestampDatepicker" class="xs">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            [matDatepicker]="analysisTimestampDatepicker"
            (click)="analysisTimestampDatepicker.open()"
            placeholder="{{ 'searchResults.filters.timestamp' | translate }}"
            autocomplete="off" test-id="acquisition-timestamp-filter">
          <mat-datepicker #analysisTimestampDatepicker></mat-datepicker>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="analysis-timestamp">{{
        element._source.analysis?.created | date:'yyyy-MM-dd HH:mm'
        }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="gearName">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('gearName') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.gearName' | translate }}"
            autocomplete="off" test-id="gear-name-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.analysis?.gear_info?.name }}"
          test-id="gear-name">{{ element._source.analysis?.gear_info?.name
          }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="gearVersion">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('gearVersion') as control">
          <mat-icon *ngIf="!control.value" class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="control.value" (click)="control.setValue('')"
            class="clear-value xs">close</mat-icon>
          <input type="text" [formControl]="$any(control)"
            placeholder="{{ 'searchResults.filters.gearVersion' | translate }}"
            autocomplete="off" test-id="gear-name-filter">
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2"
          title="{{ element._source.analysis?.gear_info?.version }}"
          test-id="gear-version">{{
          element._source.analysis?.gear_info?.version }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tags">
      <mat-header-cell *matHeaderCellDef>
        <div *ngIf="searchFilters.get('tags') as control">
          <mat-icon *ngIf="!areThereTags()"
            class="xs">filter_alt</mat-icon>
          <mat-icon *ngIf="areThereTags()"
            (click)="control.setValue(emptyTagsValue)"
            class="clear-value xs">close</mat-icon>
          <tag-select-menu [value]="$any(control.value)"
            [resultType]="resultType"
            (valueChange)="updateTagsFilter($event)"></tag-select-menu>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index;">

        <mat-chip-listbox #chipList class="chip-list">
          <mat-chip-option *ngFor="let chip of getTags(element)"
            [style]="{backgroundColor: getTagColor(chip)}">
            {{ chip }}
          </mat-chip-option>
        </mat-chip-listbox>

        <div class="chip-ellipsis"
          [style.left]="tagOverflows[i]?.ellipsisOffsetLeft"
          [style.display]="tagOverflows[i]?.hiddenItemCount > 0 ? 'block' : 'none'">
          <mat-chip-option *ngIf="tagOverflows[i]?.hiddenItemCount > 0"
            class="more-chip"
            [matTooltip]="tagOverflows[i]?.hiddenItemsTooltip">+{{
            tagOverflows[i]?.hiddenItemCount }}</mat-chip-option>
        </div>

      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="resultColumns; sticky: true"></mat-header-row>
    <mat-header-row *matHeaderRowDef="checkedStatusColumns; sticky: true"
      [class.hidden]="!((allChecked$ | async) && page?.size < page?.total) && !isLoading"></mat-header-row>
    <mat-row *matRowDef="let row; columns: resultColumns;"
      (click)="selectResultRow(row)" class="body-row list-action-hover"
      [ngClass]="{ 'selected': selectedResultId === row._id }"
      [attr.test-id]="'search-row-' + row._id"></mat-row>
  </mat-table>
</ng-template>
